import { mutationOptions } from '@tanstack/react-query';
import { getEnvironmentVariables } from '@repo/shared-config/app/helper/environment-variables';
import { getUrlsTable } from '@repo/shared-config/app/constants/hosts';
import * as users from '#proto/index.qonto.account_management.users.firstparty.v2';
import { client } from '#queries/utils';
import { type UpdateUserParams, ApiUpdateUserRequest } from './types';

const { backendUrlsTable } = getUrlsTable(getEnvironmentVariables());
const { authBaseURL } = backendUrlsTable;

/**
 * @deprecated
 * Types are not based on proto definitions
 * Requires a full representation of user because it's a PUT
 * Requires userId although we only ever update the current user
 * Prefer using updateMe which is based on proto definitions and doesn't have these issues
 */
function updateUser() {
  return mutationOptions({
    mutationFn: async ({ userId, user }: UpdateUserParams) => {
      if (!userId) throw new Error('No user id');

      const result = await client(`${authBaseURL}/v2/users/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ user }),
      });

      return users.ApiGetUserResponse.fromJSON(result);
    },
  });
}

export async function updatePhoneNumber(phoneNumber: string): Promise<void> {
  await client(`${authBaseURL}/v2/users/me/phone_number`, {
    method: 'POST',
    body: {
      user: {
        phone_number: phoneNumber,
      },
    },
  });
}

function updatePhoneNumberMutation() {
  return mutationOptions({
    mutationFn: ({ phoneNumber }: { phoneNumber: string }) => updatePhoneNumber(phoneNumber),
  });
}

export const usersMutations = {
  updateUser,
  updateMe: mutationOptions({
    mutationFn: async (data: ApiUpdateUserRequest) => {
      const result = await client(`${authBaseURL}/v2/users/me`, {
        method: 'PATCH',
        body: JSON.stringify(ApiUpdateUserRequest.toJSON(data)),
      });

      return users.ApiGetUserResponse.fromJSON(result);
    },
  }),
  updatePhoneNumber: updatePhoneNumberMutation,
};
